import { Column } from '@tanstack/react-table';

export interface ColumnFilterPopupProps<TData, TValue> {
  column: Column<TData, TValue>;
  className?: string;
}

export const isFilterHandled = <TData, TValue>(column: Column<TData, TValue>) => {
  return (
    column.getCanFilter() &&
    (Boolean(column.columnDef.meta?.customFilter) ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ['arrIncludes', 'inNumberRange'].includes(column.columnDef.filterFn as any))
  );
};
